
export function onlyText() {

    return {
        require: 'ngModel',
        restrict: 'A',
        link: (scope, element, attr, ngModelCtrl) => {


           function replacing(){

            let cleaned = ""

                if (ngModelCtrl.$viewValue) {

                    cleaned = ngModelCtrl.$viewValue.replace(/([^a-z0-9]|)/ig, "").trim();
    
                    ngModelCtrl.$setViewValue(cleaned);
    
                    ngModelCtrl.$render();
                }

                return cleaned;
            }

            ngModelCtrl.$parsers.push(replacing);

        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/directives/only-text.directive.js